<template>
  <div
    class="modal"
    tabindex="-1"
    :id="id"
    data-backdrop="static"
  >
    <div
      class="modal-dialog modal-dialog-centered"
      :class="[sizeClass]"
    >
      <div class="modal-content bg-ice">
        <div class="modal-header bg-cosmos p-3">
          <h4>{{ headerText }}</h4>
          <modal-close-button-new @confirmed="onCancel" />
        </div>
        <div class="modal-body">
          <div class="col-xl-12 form-group center">
            <label for="year-select">{{ $t('global.selectYear') }}</label>
            <select
              id="year-select"
              v-model="selectedYear"
              :class="['form-control', { 'border-danger': showYearError }]"
              @change="showYearError = false"
            >
              <option
                value=""
                disabled
              >
                {{ $t('global.pleaseSelectYear') }}
              </option>
              <option
                v-for="year in years"
                :key="year"
                :value="year"
              >
                {{ year }}
              </option>
            </select>
            <div
              v-if="showYearError"
              class="text-danger mt-2"
            >
              {{ $t('global.noYearSelectedErrorMessage') }}
            </div>
          </div>
          <div class="col-xl-12 form-group">
            <label for="week-select">{{ $t('global.selectWeek') }}</label>
            <select
              id="week-select"
              v-model="selectedWeek"
              :class="['form-control', { 'border-danger': showWeekError }]"
              @change="showWeekError = false"
            >
              <option
                value=""
                disabled
              >
                {{ $t('global.pleaseSelectWeek') }}
              </option>
              <option
                v-for="week in weeks"
                :key="week"
                :value="week"
              >
                {{ week }}
              </option>
            </select>
            <div
              v-if="showWeekError"
              class="text-danger mt-2"
            >
              {{ $t('global.noWeekSelectedErrorMessage') }}
            </div>
          </div>
          <slot></slot>
        </div>
        <div
          class="modal-footer"
          :class="{ 'd-none': noFooter }"
        >
          <div class="row w-100">
            <div class="col-12 text-center">
              <button
                v-show="cancel"
                type="button"
                class="btn btn-danger mr-3"
                data-dismiss="modal"
                @click="onCancel"
              >
                <span class="font-khand font-weight-bold">
                  {{ cancelText }}
                </span>
              </button>
              <button
                v-show="ok"
                type="button"
                class="btn btn-success"
                @click="onOk"
              >
                <span class="font-khand font-weight-bold">{{ okText }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { modal } from '../../mixins/Modal'
  import ModalCloseButtonNew from '@/components/global/ModalCloseButtonNew'

  export default {
    name: 'CreateBildungsgangFromTemplateModal',
    components: {
      ModalCloseButtonNew,
    },
    props: {
      headerText: {
        type: String,
        required: true,
      },
      ok: {
        type: Boolean,
        default: false,
      },
      cancel: {
        type: Boolean,
        default: true,
      },
      okText: {
        type: String,
        default: 'OK',
      },
      cancelText: {
        type: String,
        default: 'Abbrechen',
      },
      size: {
        type: String,
        default: null,
      },
      noFooter: {
        type: Boolean,
        default: false,
      },
    },
    mixins: [modal],
    data() {
      return {
        selectedYear: '',
        selectedWeek: '',
        showYearError: false,
        showWeekError: false,
      }
    },
    computed: {
      sizeClass() {
        if (this.size) return `modal-${this.size}`
        else return ''
      },
      years() {
        const current = new Date().getFullYear()
        return Array.from({ length: 11 }, (_, i) => current + i)
      },
      weeks() {
        return Array.from({ length: 52 }, (_, i) => i + 1)
      },
    },
    methods: {
      onCancel() {
        this.showYearError = false
        this.showWeekError = false
        this.selectedYear = ''
        this.selectedWeek = ''
        this.closeModal()
        this.$emit('cancel')
      },
      onOk() {
        this.showYearError = !this.selectedYear
        this.showWeekError = !this.selectedWeek
        if (this.showYearError || this.showWeekError) {
          return
        }
        this.showYearError = false
        this.showWeekError = false
        this.closeModal()
        this.$emit('ok', this.selectedYear, this.selectedWeek)
      },
    },
  }
</script>
